import { AuthService } from './../../shared/services/auth.service';
import { AddressesService } from './../../shared/services/addresses.service';
import { DictionaryValuesService } from '../../shared/services/dictionaryValues.service';
import { ClientsService } from './../../shared/services/clients.service';
import { SitesService } from './../../shared/services/sites.service';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { trigger, state, style } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { UiService } from '@services/ui.service';
import { Order } from '@classes/order/order';
import { OrdersService } from '@services/orders.service';
import { OrderStatus } from '@enums/order-status.enum';
import { Pagination } from '@classes/pagination/pagination';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
} from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { User } from '@classes/user/user';
import { Client } from '@classes/client';
import { Site } from '@classes/site';
import { Address } from '@classes/address';
import { UsersService } from '@services/users.service';
import { RoleName } from '@enums/role-name.enum';
import { DictionaryValue } from '@classes/dictionary/dictionaryValue';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { DialogChangeTimespentComponent } from '@components/dialog-change-timespent/dialog-change-timespent.component';
import { ExportOrdersRequest } from '@classes/order/export-orders-request';
import { MWorkerService } from '@services/m-worker.service';
import { VehiclesService } from '@services/vehicles/vehicles.service';
import { Vehicle } from '@classes/vehicles/vehicle';
import { VehicleStatus } from '@classes/vehicles/vehicle-status';

@Component({
  selector: 'app-missions-list',
  templateUrl: './missions-list.component.html',
  styleUrls: ['./missions-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', display: 'none' }),
      ),
      state('expanded', style({ height: '*' })),
    ]),
  ],
})
export class MissionsListComponent
  extends DatatableBaseComponent
  implements OnInit
{
  // CONSTANTS
  private readonly _exportSortByValue = 'senderCompletedOn';

  @Output() clearOneFilterEvent = new EventEmitter<any>();
  @ViewChild('vehicleStatusButton', { read: ElementRef })
  vehicleStatusButton: ElementRef;
  @ViewChild('timeTrackingButton', { read: ElementRef })
  timeTrackingButton: ElementRef;

  @ViewChild('vehicleStatusPanel') vehicleStatusPanel: ElementRef;
  @ViewChild('timeTrackingPanel') timeTrackingPanel: ElementRef;

  orders: Order[];
  indexToRemove = null;

  displayedColumns: string[] = [];
  displayedColumnsMenuMissions: any[] = [
    { editable: false, name: 'select', selected: true, visible: false },
    { editable: true, name: 'identifier', selected: true, visible: false },
    {
      editable: true,
      name: 'transportVoucher',
      selected: true,
      visible: false,
    },
    { editable: true, name: 'startDate', selected: true, visible: false },
    { editable: true, name: 'urgency', selected: true, visible: false },
    { editable: true, name: 'sender', selected: true, visible: false },
    { editable: true, name: 'receivers', selected: true, visible: false },
    { editable: true, name: 'status', selected: true, visible: false },
    { editable: true, name: 'client', selected: true, visible: false },
    { editable: true, name: 'site', selected: true, visible: false },
    { editable: true, name: 'lot', selected: true, visible: false },
    {
      editable: true,
      name: 'vehicleNumberplate',
      selected: true,
      visible: false,
    },
    { editable: true, name: 'createdBy', selected: true, visible: false },
    { editable: true, name: 'createdOn', selected: true, visible: false },
    { editable: true, name: 'driver', selected: true, visible: false },
    { editable: true, name: 'progressReport', selected: true, visible: false },
    { editable: false, name: 'actions', selected: true, visible: false },
  ];

  // Additional 'filter' column list
  displayedColumnFilters: string[] = ['identifier-filter'];
  dataSource: MatTableDataSource<Order>;
  orderStatus = OrderStatus;

  // filterValue: string;
  filterValue = null;
  pagination: Pagination;
  sortValue: string;

  dispatchers: User[];
  drivers: User[];
  clients: Client[];
  sites: Site[];
  urgencies: DictionaryValue[];
  senders: Address[];
  receivers: Address[];
  users: User[];
  usersLastTimeRecords: User[] = [];
  lots: DictionaryValue[];
  vehicles: Vehicle[] = [];
  vehicleStatus: VehicleStatus[] = [];

  isLoadingFilterForm: boolean;
  isLoadingTimeTracking: boolean = true;
  isLoadingVehicleStatus: boolean = true;

  globalFilter = '';
  canExport = false;

  filterForm = new UntypedFormGroup({
    identifier: new UntypedFormControl(),
    transportVoucher: new UntypedFormControl(),
    status: new UntypedFormControl(),
    dispatcher: new UntypedFormControl(),
    client: new UntypedFormControl(),
    site: new UntypedFormControl(),
    createdBy: new UntypedFormControl(),
    startDate: new UntypedFormControl(),
    range: new UntypedFormGroup({
      fromStartDate: new UntypedFormControl(null),
      toStartDate: new UntypedFormControl(null),
    }),
    urgency: new UntypedFormControl(),
    sender: new UntypedFormControl(),
    receiver: new UntypedFormControl(),
    driver: new UntypedFormControl(),
    includeDeleted: new UntypedFormControl(),
    lot: new UntypedFormControl(),
    vehicle: new UntypedFormControl(),
  });

  filteredValues = {
    identifier: '',
    transportVoucher: '',
    startDate: '',
    status: '',
    dispatcher: '',
    client: '',
    site: '',
    createdBy: '',
    urgency: '',
    sender: '',
    receiver: '',
    driver: '',
    lot: '',
    vehicle: '',
  };

  isDispatcher: boolean;
  isAdmin: boolean;
  isClient: boolean;

  initialSelection = [];
  allowMultiSelect = true;
  selection = new SelectionModel<any>(
    this.allowMultiSelect,
    this.initialSelection,
  );

  timeTrackingPanelOpen = false;
  vehicleStatusPanelOpen = false;

  allStatus: any[] = [
    {
      value: 'all',
      name: 'Tous',
    },
    {
      value: 4,
      name: 'Traitée par un régulateur',
    },
    {
      value: 8,
      name: 'Acceptée par un chauffeur',
    },
    {
      value: 16,
      name: 'Terminée',
    },
    {
      value: 32,
      name: 'Annulée',
    },
    {
      value: 64,
      name: 'Modifiée',
    },
    {
      value: 128,
      name: 'En cours',
    },
    {
      value: 256,
      name: 'A réaffecter',
    },
  ];

  private clickListener: () => void;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private ordersSrv: OrdersService,
    private router: Router,
    private sitesSrv: SitesService,
    private clientsSrv: ClientsService,
    private dictionarySrv: DictionaryValuesService,
    private addressesSrv: AddressesService,
    private usersSrv: UsersService,
    private authSrv: AuthService,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private _mWorkerService: MWorkerService,
    private _vehiclesService: VehiclesService,
    private renderer: Renderer2,
  ) {
    super(uiSrv);

    this.clickListener = this.renderer.listen('window', 'click', (e: Event) => {
      if (this.timeTrackingButton && this.vehicleStatusButton) {
        if (
          e.target !== this.timeTrackingButton.nativeElement &&
          e.target !== this.timeTrackingPanel?.nativeElement
        ) {
          this.closePanel('timeTrackingPanel');
        }
        if (
          e.target !== this.vehicleStatusButton.nativeElement &&
          e.target !== this.vehicleStatusPanel?.nativeElement
        ) {
          this.closePanel('vehicleStatusPanel');
        }
      }
    });
  }

  ngOnInit() {
    if (sessionStorage.getItem('missionFilters')) {
      this.filterValue = JSON.parse(sessionStorage.getItem('missionFilters'));
    }
    if (this.usersSrv.globalSelectedClient) {
      this.filterValue = {
        ...this.filterValue,
        client: this.usersSrv.globalSelectedClient.name,
      };
    }

    this.isDispatcher =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.dispatcher;

    this.canExport =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.admin_client;

    this.isAdmin =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin;

    this.isClient =
      this.authSrv.getUser().role.name === RoleName.admin_client ||
      this.authSrv.getUser().role.name === RoleName.client;

    if (this.isAdmin) {
      this.displayedColumnsMenuMissions.splice(
        this.displayedColumnsMenuMissions.length - 1,
        0,
        { editable: true, name: 'timeSpent', selected: true, visible: false },
      );
    }

    super.ngOnInit();
    this.checkIfColumnsInStorage();
    this.initSubscriptions();
  }

  ngOnDestroy(): void {
    this.clickListener();
  }

  ngAfterViewInit(): void {
    if (sessionStorage.getItem('missionFilters')) {
      this.initForm();
    }
  }

  ngAfterViewChecked(): void {
    this.ref.detectChanges();
  }

  checkIfColumnsInStorage(): void {
    if (localStorage.getItem('displayedColumnsMenuMissions')) {
      this.displayedColumnsMenuMissions = JSON.parse(
        localStorage.getItem('displayedColumnsMenuMissions'),
      );
    } else {
      this.displayedColumnsMenuMissions = [
        { editable: false, name: 'select', selected: true, visible: false },
        { editable: true, name: 'identifier', selected: true, visible: false },
        {
          editable: true,
          name: 'transportVoucher',
          selected: true,
          visible: false,
        },
        { editable: true, name: 'startDate', selected: true, visible: false },
        { editable: true, name: 'urgency', selected: true, visible: false },
        { editable: true, name: 'sender', selected: true, visible: false },
        { editable: true, name: 'receivers', selected: true, visible: false },
        { editable: true, name: 'status', selected: true, visible: false },
        { editable: true, name: 'client', selected: true, visible: false },
        { editable: true, name: 'site', selected: true, visible: false },
        { editable: true, name: 'lot', selected: true, visible: false },
        {
          editable: true,
          name: 'vehicleNumberplate',
          selected: true,
          visible: false,
        },
        { editable: true, name: 'createdBy', selected: true, visible: false },
        { editable: true, name: 'createdOn', selected: true, visible: false },
        { editable: true, name: 'driver', selected: true, visible: false },
        {
          editable: true,
          name: 'progressReport',
          selected: true,
          visible: false,
        },
        { editable: false, name: 'actions', selected: true, visible: false },
      ];
      if (this.isAdmin) {
        this.displayedColumnsMenuMissions.splice(
          this.displayedColumnsMenuMissions.length - 1,
          0,
          { editable: true, name: 'timeSpent', selected: true, visible: false },
        );
      }
    }
  }

  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].name === obj.name) {
        this.indexToRemove = i;
        return true;
      }
    }

    return false;
  }

  showStatusText(status: OrderStatus): string {
    return 'orders.status.' + OrderStatus[status];
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  onFilter(): void {
    this.selection.clear();
    const formValue = this.filterForm.value;

    this.filterValue = formValue;
    this.saveFilterInSessionStorage();
    this.getList();
  }

  clearFilters(): void {
    this.filterForm.reset();
    this.filterValue = null;
    this.sortValue = null;
    this.sort.active = '';
    this.sort.direction = '';
    this.sort.sortChange.emit();
    this.clearFilterSessionStorage();
    this.getList();
  }

  filterEnter(event: Event, column) {
    this.filterValue = this.filterForm.value;
    this.saveFilterInSessionStorage();
    this.getList();
  }

  initForm() {
    const filterValue = this.filterValue;

    let site = filterValue.site;
    let createdBy = filterValue.createdBy;

    if (filterValue.site && typeof filterValue.site !== 'string') {
      site = Site.fromObject(site);
    }

    if (filterValue.createdBy && typeof filterValue.createdBy !== 'string') {
      createdBy = User.fromObject(createdBy);
    }

    this.filterForm = new UntypedFormGroup({
      identifier: new UntypedFormControl(filterValue.identifier),
      transportVoucher: new UntypedFormControl(filterValue.transportVoucher),
      status: new UntypedFormControl(filterValue.status),
      dispatcher: new UntypedFormControl(filterValue.dispatcher),
      client: new UntypedFormControl(filterValue.client),
      site: new UntypedFormControl(site),
      createdBy: new UntypedFormControl(createdBy),
      startDate: new UntypedFormControl(filterValue.startDate),
      range: new UntypedFormGroup({
        fromStartDate: new UntypedFormControl(filterValue.range.fromStartDate),
        toStartDate: new UntypedFormControl(filterValue.range.toStartDate),
      }),
      urgency: new UntypedFormControl(filterValue.urgency),
      sender: new UntypedFormControl(filterValue.sender),
      receiver: new UntypedFormControl(filterValue.receiver),
      driver: new UntypedFormControl(filterValue.driver),
      includeDeleted: new UntypedFormControl(filterValue.includeDeleted),
      lot: new UntypedFormControl(filterValue.lot),
      vehicle: new UntypedFormControl(filterValue.vehicle),
    });
  }

  saveFilterInSessionStorage() {
    sessionStorage.setItem('missionFilters', JSON.stringify(this.filterValue));
  }

  clearFilterSessionStorage() {
    sessionStorage.removeItem('missionFilters');
  }

  onPageChanged(pageEvent: PageEvent): void {
    this.selection.clear();
    this.pagination.pageNumber = pageEvent.pageIndex + 1;
    this.getList();
  }

  onSortChanged(sortEvent: Sort): void {
    let direction = '';

    if (sortEvent) {
      if (sortEvent.direction === 'asc') {
        direction = '';
      } else if (sortEvent.direction === 'desc') {
        direction = '-';
      }

      if (sortEvent.direction === '') {
        this.sortValue = null;
      } else {
        this.sortValue = `${direction}${sortEvent.active}`;
      }
    }

    if (!this.sortValue) {
      this.sortValue = '-startDate';
    }

    this.getList();
  }

  public onExportSelection(exportOrdersRequest: ExportOrdersRequest): void {
    if (exportOrdersRequest.isOnlyExcelSelected()) {
      this._exportSelectionExcel();
    } else {
      this._exportSelection(exportOrdersRequest);
    }
  }

  private _exportSelectionExcel(): void {
    const idOrders = this._getSelectedOrdersIds();
    this.ordersSrv.exportExcel(idOrders).subscribe(() => {
      this.selection.clear();
    });
  }

  private _exportSelection(exportOrdersRequest: ExportOrdersRequest): void {
    this._addCommunFieldsInExportOrdersRequest(exportOrdersRequest);
    exportOrdersRequest.orderIds = this._getSelectedOrdersIds();

    this._exportOrders(exportOrdersRequest);
    this.selection.clear();
    this._displayExportOrdersRequestNotification();
  }

  private _getSelectedOrdersIds(): string[] {
    const selectedOrdersIds: string[] = [];
    this.selection.selected.map((order) => {
      selectedOrdersIds.push(order.id);
    });

    return selectedOrdersIds;
  }

  public onExportAll(exportOrdersRequest: ExportOrdersRequest): void {
    if (exportOrdersRequest.isOnlyExcelSelected()) {
      this._exportAllExcel();
    } else {
      this._exportAll(exportOrdersRequest);
    }
  }

  private _exportAllExcel(): void {
    const newRequest = new PaginationRequest(
      this.filterValue,
      this._exportSortByValue,
      null,
      null,
    );
    this.ordersSrv.exportExcelAll(newRequest, true).subscribe(() => {});
  }

  private _exportAll(exportOrdersRequest: ExportOrdersRequest): void {
    this._addCommunFieldsInExportOrdersRequest(exportOrdersRequest);
    exportOrdersRequest.filters.filters = this.ordersSrv.generateFiltersQuery(
      this.filterForm.value,
    );
    exportOrdersRequest.filters.sorts = this._exportSortByValue;

    this._exportOrders(exportOrdersRequest);
    this._displayExportOrdersRequestNotification();
  }

  private _exportOrders(exportOrdersRequest: ExportOrdersRequest): void {
    this.ordersSrv.export$(exportOrdersRequest).subscribe();
  }

  private _displayExportOrdersRequestNotification(): void {
    this.uiSrv.showSnackbar(
      "Votre demande d'export à été faite. Vous recevrez une notification lorsque vos documents seront prêts.",
      false,
      5000,
    );
  }

  private _addCommunFieldsInExportOrdersRequest(
    exportOrdersRequest: ExportOrdersRequest,
  ): void {
    exportOrdersRequest.includePrices = false;
    exportOrdersRequest.isAssigned = true;
    exportOrdersRequest.generateFileName();
  }

  onSelectOrder(id: string): void {
    this.router.navigate([`orders/${id}`]);
  }

  getList(): void {
    const newRequest = new PaginationRequest(
      this.filterValue,
      this.sortValue,
      this.pagination.pageNumber,
    );

    this.ordersSrv.getList(newRequest, true);
  }

  getProgressReport(order: Order): string {
    const numberOfSteps = order.receivers ? order.receivers.length + 1 : 1;
    const numberOfStepsDone =
      (order.sender?.completedOn ? 1 : 0) +
      (order.receivers.filter((receiver) => receiver.completedOn).length || 0);

    return `${numberOfStepsDone}/${numberOfSteps}`;
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.orders);
    this.dataSource.sort = this.sort;
  }

  private initSubscriptions(): void {
    const newRequest = new PaginationRequest(this.filterValue);
    this.ordersSrv.getList(newRequest, true);

    this.addSubscription(
      this.ordersSrv.ordersListChanged.subscribe((orders) => {
        this.orders = orders;
        this.setDisplayedColumns();
        this.initTable();
      }),
    );

    this.addSubscription(
      this.usersSrv.globalSelectedClientSubject.subscribe((client) => {
        this.filterValue = {
          ...this.filterValue,
          client: client ? client.name : null,
        };
        this.getList();
      }),
    );

    if (this.isAdmin && !this.isClient) {
      this.addSubscription(
        this.usersSrv.getUsersLastTimeRecords().subscribe({
          next: (users) => {
            this.usersLastTimeRecords = users;
            this.isLoadingTimeTracking = false;
          },
          error: (error) => {
            console.error('error', error);
            this.isLoadingTimeTracking = false;
          },
        }),
      );
    } else {
      this.isLoadingTimeTracking = false;
    }

    if (!this.isClient) {
      this.addSubscription(
        this._vehiclesService.getStatusList().subscribe({
          next: (vehicleStatus) => {
            this.vehicleStatus = vehicleStatus;
            this.isLoadingVehicleStatus = false;
          },
          error: (error) => {
            console.error('error', error);
            this.isLoadingVehicleStatus = false;
          },
        }),
      );
    }

    this.isLoadingFilterForm = true;

    const lotsPromise = new Promise((resolve) => {
      this.dictionarySrv.getLotsList().subscribe((lotsFromSrv) => {
        this.lots = lotsFromSrv;
        resolve(true);
      });
    });

    const vehiclesPromise = new Promise((resolve) => {
      this._vehiclesService.getList().subscribe((vehicles) => {
        this.vehicles = vehicles;
        resolve(true);
      });
    });

    const sitesPromise = new Promise((resolve) => {
      this.sitesSrv.getList().subscribe((sitesFromSrv) => {
        this.sites = sitesFromSrv;
        resolve(true);
      });
    });

    const clientsPromise = new Promise((resolve) => {
      this.clientsSrv.getList().subscribe((clientsFromSrv) => {
        this.clients = clientsFromSrv;
        resolve(true);
      });
    });

    const urgencyLevelsPromise = new Promise((resolve) => {
      this.dictionarySrv.getUrgencyList().subscribe((urgencyLevelsFromSrv) => {
        this.urgencies = urgencyLevelsFromSrv;
        resolve(true);
      });
    });

    const driversPromise = new Promise((resolve) => {
      this.usersSrv.getList(RoleName.driver).subscribe((driversFromSrv) => {
        this.drivers = driversFromSrv;
        resolve(true);
      });
    });

    const addressPromise = new Promise((resolve) => {
      this.addressesSrv.getList().subscribe((addressessFromSrv) => {
        this.senders = addressessFromSrv.filter((address) => address.isSender);
        this.receivers = addressessFromSrv.filter(
          (address) => address.isReceiver,
        );
        resolve(true);
      });
    });

    const usersPromise = new Promise((resolve) => {
      this.usersSrv.getList().subscribe((usersFromSrv) => {
        let system = new User('Système', null, null, null, null, null);
        system.id = 'system';
        let all = new User('Tous', null, null, null, null, null);
        all.id = 'all';
        this.users = usersFromSrv;
        this.users.push(system);
        this.users.push(all);
        resolve(true);
      });
    });

    Promise.all([
      lotsPromise,
      vehiclesPromise,
      sitesPromise,
      clientsPromise,
      urgencyLevelsPromise,
      addressPromise,
      driversPromise,
      usersPromise,
    ]).then(() => {
      this.isLoadingFilterForm = false;
    });

    this.addSubscription(
      this.ordersSrv.paginationSubject.subscribe((pagination) => {
        this.pagination = pagination;
      }),
    );
  }

  changeStatus(status: string, order: Order): void {
    const statusToSend = {
      status: 0,
      comment: null,
    };

    let canSend = true;

    if (status === 'receivedByDispatcher') {
      statusToSend.status = 2;
    } else if (status === 'treatedByDispatcher') {
      statusToSend.status = 4;
    } else if (status === 'finished') {
      statusToSend.status = 16;
      canSend = confirm('Etes-vous certain de terminer cette commande ?');
    } else if (status === 'cancelled') {
      statusToSend.status = 32;
      canSend = confirm("Etes-vous certain d'annuler cette commande ?");
    }

    if (canSend) {
      this.ordersSrv
        .changeStatus(order.id, statusToSend)
        .subscribe((results) => {
          order.status = results.status;
          order.statusChanges = results.statusChanges;
        });
    }
  }

  delete(order: Order): void {
    const confirmation = confirm(
      'Êtes-vous certain de vouloir supprimer cette mission ?',
    );
    if (confirmation) {
      this.ordersSrv.delete(order.id).subscribe(() => {
        this.uiSrv.showSnackbar('Mission supprimée avec succès', false);
      });
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    // Swap the elements around
    moveItemInArray(
      this.displayedColumnsMenuMissions,
      event.previousIndex,
      event.currentIndex,
    );
    localStorage.setItem(
      'displayedColumnsMenuMissions',
      JSON.stringify(this.displayedColumnsMenuMissions),
    );
    this.setDisplayedColumns();
  }

  onSelectMenu(event, name) {
    this.displayedColumnsMenuMissions.find((f) => f.name === name).selected =
      event.checked;
    localStorage.setItem(
      'displayedColumnsMenuMissions',
      JSON.stringify(this.displayedColumnsMenuMissions),
    );
    this.setDisplayedColumns();
  }

  private setDisplayedColumns(): void {
    this.displayedColumns = this.displayedColumnsMenuMissions
      .filter((f) => (f || {}).selected)
      .map((m) => m.name);
  }

  getControl(control: string): UntypedFormControl {
    return this.filterForm.get(control) as UntypedFormControl;
  }

  changeTimeSpent(order: Order) {
    const dialogRef = this.dialog.open(DialogChangeTimespentComponent, {
      width: '250px',
      data: { orderId: order.id },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  public openInMworker(order: Order): void {
    this._mWorkerService.openOrderInMworker(order);
  }

  public displayMworkerButton(order: Order): boolean {
    return this._mWorkerService.canGenerateLink(order);
  }

  openPanel(panel: string) {
    if (panel === 'timeTrackingPanel') {
      this.timeTrackingPanelOpen = true;
    } else {
      this.vehicleStatusPanelOpen = true;
    }

    if (document.getElementById(panel)) {
      document.getElementById(panel).style.height = '250px';
    }
  }

  closePanel(panel: string) {
    if (panel === 'timeTrackingPanel') {
      this.timeTrackingPanelOpen = false;
    } else {
      this.vehicleStatusPanelOpen = false;
    }
    if (document.getElementById(panel)) {
      document.getElementById(panel).style.height = '0';
    }
  }
}
